import { useEffect } from "react";
import us from './../../data/us.json';

export default function Bok() {
    useEffect(() => {
        document.title = '💛 bok gallery ❤️';
    });

    function modifyPath(path) {
        if (path)
            return 'https://drive.google.com/thumbnail?id=' + path + '&sz=w800';
        else
            return 'https://drive.google.com/thumbnail?id=1Wvotxejih2ttQ6XyM8f3xfPI9Xk702Sr&sz=w800';
    }

    return (
        <>
            <div class='d-flex flex-column align-items-center justify-content-center h-100 w-75 her-font mx-auto pb-5'>
                <div class='fs-1 fw-bold text-center w-100 my-4 bg-light bg-gradient rounded-5 shadow-lg'>
                    💛 Us Moments ❤️
                </div>
                {
                    us.moments.map((moment, i) => {
                        return (
                            <div class={(i % 2 === 0) ? 'card w-100 mb-1 shadow-lg tilt-left' : 'card w-100 mb-1 shadow-lg tilt-right'} key={'moment-' + i}>
                                <div class='card-header w-100 fw-semibold d-flex justify-content-between bg-dark fs-3'>
                                    <span class='text-warning'>{'#' + (i + 1)}</span><span class='text-danger'>🗓️ {moment.date}</span>
                                </div>
                                <div id={'carousel-' + i} class='carousel slide'>
                                    {
                                        (moment.photos.length > 1) ?
                                            <div class="carousel-indicators">
                                                {
                                                    moment.photos.map((e, j) => {
                                                        return (
                                                            <button type="button" data-bs-target={'#carousel-' + i} data-bs-slide-to={j} class='active' aria-current='true' aria-label={'Slide ' + j} key={'moment-' + i + '-carouselbutton-' + j}></button>
                                                        )
                                                    })
                                                }
                                            </div>
                                        : <></>
                                    }

                                    <div class="carousel-inner">
                                        {
                                            moment.photos.map((photo, j) => {
                                                return (
                                                    <div class={(j === 0) ? 'carousel-item active' : 'carousel-item'}>
                                                        <img src={modifyPath(photo.path)} alt={photo.caption} class='d-block zoom-img w-100' />
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    {
                                        (moment.photos.length > 1) ? <>
                                            <button class="carousel-control-prev" type="button" data-bs-target={'#carousel-' + i} data-bs-slide="prev">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Previous</span>
                                            </button>

                                            <button class="carousel-control-next" type="button" data-bs-target={'#carousel-' + i} data-bs-slide="next">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="visually-hidden">Next</span>
                                            </button>
                                        </> : <></>
                                    }
                                </div>

                                <div class='card-body bg-dark'>
                                    <p class='card-text text-center text-light fs-4'>{moment.description}</p>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </>
    );
}